<template>
  <div class="party-a-container">
    <div class="page-title">甲方信息管理</div>

    <!-- 甲方信息表单区域 -->
    <div class="form-card">
      <el-form
        ref="partyAForm"
        :model="partyAInfo"
        :rules="rules"
        label-width="100px"
        class="info-form"
      >
        <!-- 甲方名称 -->
        <el-form-item label="甲方名称" prop="partyAName">
          <el-input
            v-model="partyAInfo.partyAName"
            :disabled="!isEdit"
            placeholder="请输入甲方名称"
          ></el-input>
        </el-form-item>

        <!-- 甲方联系人 -->
        <el-form-item label="甲方联系人" prop="contactPerson">
          <el-input
            v-model="partyAInfo.contactPerson"
            :disabled="!isEdit"
            placeholder="请输入甲方联系人"
          ></el-input>
        </el-form-item>

        <!-- 甲方联系电话 -->
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input
            v-model="partyAInfo.contactPhone"
            :disabled="!isEdit"
            placeholder="请输入甲方联系电话"
          ></el-input>
        </el-form-item>

        <!-- 甲方邮箱 -->
        <el-form-item label="甲方邮箱" prop="email">
          <el-input
            v-model="partyAInfo.email"
            :disabled="!isEdit"
            placeholder="请输入甲方邮箱"
            type="email"
          ></el-input>
        </el-form-item>

        <!-- 甲方住所地 -->
        <el-form-item label="甲方住所地" prop="address">
          <el-input
            v-model="partyAInfo.address"
            :disabled="!isEdit"
            placeholder="请输入甲方住所地"
            type="textarea"
            :rows="3"
          ></el-input>
        </el-form-item>

        <!-- 新增：甲方邮寄地址 -->
        <el-form-item label="甲方邮寄地址" prop="postalAddress">
          <el-input
            v-model="partyAInfo.postalAddress"
            :disabled="!isEdit"
            placeholder="请输入甲方邮寄地址"
            type="textarea"
            :rows="3"
          ></el-input>
        </el-form-item>

        <!-- 甲方法人 -->
        <el-form-item label="甲方法人" prop="legalPerson">
          <el-input
            v-model="partyAInfo.legalPerson"
            :disabled="!isEdit"
            placeholder="请输入甲方法人"
          ></el-input>
        </el-form-item>
      </el-form>

      <!-- 操作按钮区域 -->
      <div class="btn-group">
        <el-button type="primary" @click="handleEdit" v-if="!isEdit">
          修改
        </el-button>
        <el-button type="success" @click="handleSave" v-if="isEdit">
          保存
        </el-button>
        <el-button @click="handleCancel" v-if="isEdit"> 取消 </el-button>
      </div>
    </div>
  </div>
</template>

<script>
// 引入API和社区ID获取方法（参考打印合同示例）
import { getPartyAInfo, updatePartyAInfo } from "@/api/oa/partyAInfoApi";
import { getCommunityId } from "@/api/community/communityApi";

export default {
  name: "PartyAInfo",
  data() {
    // 手机号校验规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入联系电话"));
      } else {
        const reg = /^1[3-9]\d{9}$/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确的11位手机号"));
        } else {
          callback();
        }
      }
    };

    // 邮箱校验规则
    const validateEmail = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入邮箱"));
      } else {
        const reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确的邮箱格式"));
        } else {
          callback();
        }
      }
    };

    return {
      // 是否处于编辑状态（默认禁用输入框）
      isEdit: false,
      // 甲方信息数据（新增postalAddress字段）
      partyAInfo: {
        paId: "9000000000000001", // 固定甲方ID（单条数据场景）
        partyAName: "", // 甲方名称（前端绑定字段）
        contactPerson: "", // 甲方联系人
        contactPhone: "", // 联系电话
        email: "", // 甲方邮箱
        address: "", // 甲方住所地
        postalAddress: "", // 新增：甲方邮寄地址
        legalPerson: "", // 甲方法人
        communityId: "", // 社区ID（框架必填）
      },
      // 表单校验规则（新增postalAddress校验）
      rules: {
        partyAName: [
          { required: true, message: "请输入甲方名称", trigger: "blur" },
        ],
        contactPerson: [
          { required: true, message: "请输入甲方联系人", trigger: "blur" },
        ],
        contactPhone: [{ validator: validatePhone, trigger: "blur" }],
        email: [{ validator: validateEmail, trigger: "blur" }],
        address: [
          { required: true, message: "请输入甲方住所地", trigger: "blur" },
        ],
        postalAddress: [
          { required: true, message: "请输入甲方邮寄地址", trigger: "blur" },
        ],
        legalPerson: [
          { required: true, message: "请输入甲方法人", trigger: "blur" },
        ],
      },
      // 备份原始数据（取消编辑时恢复）
      originData: {},
    };
  },
  created() {
    // 初始化社区ID（参考打印合同示例）
    this.partyAInfo.communityId = getCommunityId();
    // 页面加载时查询甲方信息
    this._loadPartyAInfo();
  },
  methods: {
    /**
     * 加载甲方信息（调用后台接口）
     */
    _loadPartyAInfo() {
      // 构造查询参数（参考打印合同的参数格式）
      const param = {
        paId: this.partyAInfo.paId,
        communityId: this.partyAInfo.communityId,
      };

      // 调用查询接口（参考打印合同的接口调用规范）
      getPartyAInfo(param)
        .then((res) => {
          // 关键修复1：解析正确的数据层级（接口返回的有效数据在res.data.data）
          const _data = res.data.data || {};
          console.log("接口返回的甲方信息：", _data); // 调试用，可查看实际返回数据

          // 关键修复2：字段名映射（接口的partyName → 前端的partyAName）
          this.partyAInfo = {
            ...this.partyAInfo, // 保留paId和communityId
            partyAName: _data.partyAName || "", // 映射甲方名称字段
            contactPerson: _data.contactPerson || "",
            contactPhone: _data.contactPhone || "",
            email: _data.email || "",
            address: _data.address || "",
            postalAddress: _data.postalAddress || "", // 新增：映射邮寄地址字段
            legalPerson: _data.legalPerson || "",
            paId: _data.paId || this.partyAInfo.paId, // 同步接口返回的paId
          };

          // 备份原始数据（用于取消编辑）
          this.originData = { ...this.partyAInfo };
        })
        .catch((error) => {
          console.error("查询甲方信息失败:", error);
          this.$message.error("查询甲方信息失败，请稍后重试");
        });
    },

    /**
     * 点击修改按钮 - 进入编辑状态
     */
    handleEdit() {
      this.isEdit = true;
    },

    /**
     * 点击保存按钮 - 提交修改（调用后台接口）
     */
    handleSave() {
      this.$refs.partyAForm.validate((valid) => {
        if (valid) {
          // 提交前处理字段映射（如果后端更新接口需要partyName，这里要转换）
          const submitData = {
            ...this.partyAInfo,
            partyName: this.partyAInfo.partyAName, // 前端partyAName → 后端partyName
            // 新增：邮寄地址字段透传给后端
            postalAddress: this.partyAInfo.postalAddress,
          };
          // 调用修改接口
          updatePartyAInfo(submitData)
            .then(() => {
              this.$message.success("甲方信息修改成功！");
              // 保存后退出编辑状态
              this.isEdit = false;
              // 更新备份数据
              this.originData = { ...this.partyAInfo };
            })
            .catch((error) => {
              console.error("修改甲方信息失败:", error);
              this.$message.error("修改甲方信息失败，请稍后重试");
            });
        } else {
          this.$message.error("请填写正确的甲方信息！");
          return false;
        }
      });
    },

    /**
     * 点击取消按钮 - 放弃修改，恢复原始数据
     */
    handleCancel() {
      // 恢复原始数据（包含新增的邮寄地址）
      this.partyAInfo = { ...this.originData };
      // 退出编辑状态
      this.isEdit = false;
      // 清空表单校验提示
      this.$refs.partyAForm.clearValidate();
    },
  },
};
</script>

<style scoped>
.party-a-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.page-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.form-card {
  background: #fff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.info-form {
  margin-bottom: 20px;
}

.btn-group {
  text-align: center;
  margin-top: 30px;
}

.btn-group .el-button {
  margin: 0 10px;
  width: 120px;
}
</style>
